import { Pipe, PipeTransform } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { Rental, selectRentalChildren, selectRentalSubUnits } from '../stores'
import { Observable, of } from 'rxjs'

@Pipe({
  name: 'rentalChildren',
  standalone: false,
})
export class RentalChildrenPipe implements PipeTransform {
  constructor(private store: Store<any>) {}

  transform(rentalId: string, type: 'parent' | 'multi' = 'parent'): Observable<Rental[]> {
    if (type === 'parent') {
      return this.store.pipe(select(selectRentalChildren(rentalId)))
    } else if (type === 'multi') {
      return this.store.pipe(select(selectRentalSubUnits(rentalId)))
    }
    return of([])
  }
}
